export default __webpack_public_path__ + "static/media/LAMA.a9cda935.gif";